import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../data.service';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { IdiomaDemanat } from '../lib/model/idiomademanat';
import { NgForm } from '@angular/forms';
import { MatStepper, MatSnackBar } from '@angular/material';
import { BLEnum } from '../lib/bl/blenum';
import { Enum } from '../lib/model/enum';
import { BLPreinscripcio } from '../lib/bl/blpreinscripcio';

@Component({
  selector: 'app-idiomes',
  templateUrl: './idiomes.component.html',
  styleUrls: ['./idiomes.component.css'],
  providers: [BLEnum, BLPreinscripcio]
})
export class IdiomesComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  dataService: DataService;
  preinscripcio: Preinscripcio;
  nivells_idioma: Enum[];
  stepPerformed = false;

  constructor(
      dataService: DataService,
      public blEnum: BLEnum,
      private blPreinscripcio: BLPreinscripcio,
      public snackBar: MatSnackBar
  ) {
    this.dataService = dataService;
    this.preinscripcio = this.dataService.preinscripcio;
  }

  async ngOnInit() {
    await this.loadNivellIdioma();
  }

  async loadNivellIdioma() {
    this.nivells_idioma = await this.blEnum.list(
      'Udg.GausNET.Model.PreInscripcions.Nivells',
      this.dataService.current_language);
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      for (let index = 0; index < this.preinscripcio.idiomes.length; index++) {
        const element = this.preinscripcio.idiomes[index];
        if (element.nivell < 1) {
          return false;
        }
      }
      if (this.preinscripcio.swAssabentatIdioma == null || !this.preinscripcio.swAssabentatIdioma) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.preinscripcio.isnew) {
        this.preinscripcio = await this.blPreinscripcio.save(this.preinscripcio);
        this.dataService.preinscripcio = this.preinscripcio;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/idiomes/idiomes.component.ts